import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Host } from '../../../../../Host';
import { Copy, Flexer } from '../../../../dashboard/elements/LayoutElements';
import { useAssitantToolCallResult, useSubmitToolResult } from '../../AssistantHooks';
import { AssitantToolSupport } from '../../AssistantToolSupport';
import { ToolCallPart } from '../../ChatTypes';

const useCallGenerateImage = () => {

    const api = `${Host.baseUrl}/api/v2/llm.image`;

    return useCallback(async (prompt: string) => {
        const result = await axios.post(api, { prompt }, {
            responseType: 'text',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return result.data;
    }, []);
};

const GenerateImageToolCallView = React.memo(({ toolCallId, args }: ToolCallPart) => {

    const submitToolResult = useSubmitToolResult();
    const result = useAssitantToolCallResult(toolCallId);
    const callGenerateImage = useCallGenerateImage();
    const called = useRef(false);
    const [images, setImages] = useState<any[]>([]);

    useEffect(() => {
        if (!called.current && !result) {
            called.current = true;
            callGenerateImage(args.prompt || 'A cat in a hat').then(setImages).then(
                () => submitToolResult(toolCallId, true)
            );
        }
    }, [result]);

    return <Flexer padding=".5">
        <Copy flush>
            {!images.length && <>Generating image...</>}
            {images.map((x, i) => <img key={i} src={`data:image/png;base64,${x.base64Data}`} />)}
        </Copy>
    </Flexer>;
});

export const GenerateImageToolSupport = AssitantToolSupport({
    toolName: 'generateImage',
    ui: GenerateImageToolCallView
});
